var path = '/assets/js/app.html';
var html = "    <div class=\"sidebar-menu\" ui-view=\"sidebar\">\n    </div>\n    <div class=\"main-content\">\n        <div class=\"row\" ui-view=\"header\"></div>\n        <div ui-view=\"main\"></div>\n    </div>\n<version-label></version-label>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;